import { render, staticRenderFns } from "./TalkOver.vue?vue&type=template&id=f21eff3e&scoped=true&"
import script from "./TalkOver.vue?vue&type=script&lang=js&"
export * from "./TalkOver.vue?vue&type=script&lang=js&"
import style0 from "./TalkOver.vue?vue&type=style&index=0&id=f21eff3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21eff3e",
  null
  
)

export default component.exports